import { Directive, HostListener, inject } from '@angular/core';

import { DialogRef } from './dialog-ref';

@Directive({
  selector: '[appDialogCloser]',
  standalone: true,
})
export class DialogCloserDirective {
  readonly #dialogRef = inject(DialogRef);

  @HostListener('click')
  public onClick(): void {
    this.#dialogRef.dismiss();
  }
}
